import { Preset } from './types'
import { DEFAULT_TRANSCRIPTION_CONFIG } from './defaults'

export const PRESETS: Record<string, Preset> = {
  default: {
    name: 'Default',
    description: 'Balanced settings for most tracks',
    config: DEFAULT_TRANSCRIPTION_CONFIG,
  },
  electronic: {
    name: 'Electronic Production',
    description: 'Tight quantization, no swing',
    config: {
      ...DEFAULT_TRANSCRIPTION_CONFIG,
      resolution: 64,
      electronic: true,
      quantize: 16,
      swing: false,
      humanFeel: false,
      humanize: false,
      velocity: false,
    },
  },
  livePerformance: {
    name: 'Live Performance',
    description: 'Preserve dynamics and human feel',
    config: {
      ...DEFAULT_TRANSCRIPTION_CONFIG,
      resolution: 64,
      swing: true,
      humanFeel: true,
      humanize: true,
      velocity: true,
      quantize: 0,
      enhanced: true,
    },
  },
  minimal: {
    name: 'Minimal/Fast',
    description: 'Basic settings for faster processing',
    config: {
      ...DEFAULT_TRANSCRIPTION_CONFIG,
      resolution: 32,
      larsnet: false,
      enhanced: false,
      velocity: false,
      soundMatch: false,
      melodyMode: 'none',
    },
  },
  highQuality: {
    name: 'High Quality',
    description: 'Maximum accuracy, slower processing',
    config: {
      ...DEFAULT_TRANSCRIPTION_CONFIG,
      resolution: 64,
      larsnet: true,
      enhanced: true,
      velocity: true,
      soundMatch: true,
      melodyMode: 'all',
      crepe: 'all',
      splitStems: true,
    },
  },
}
